import React from "react";
import { Button } from "antd";
import PaymentAndTransaction from "../../components/tables/PaymentAndTransaction";

const PaymentAndTransactionPage = () => {
	return (
		<>
			<PaymentAndTransaction button={Button} />
		</>
	);
};

export default PaymentAndTransactionPage;
